import { version } from '../../package.json'

export const week = {
  0: '星期日',
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六',
}

export const appVersion = 'v' + version



// WEBPACK FOOTER //
// ./src/constants/general.js